"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileEditUploadPhoto = void 0;
const react_1 = __importStar(require("react"));
const profile_avatar_1 = require("@shared-modules/components/profile-avatar");
const title_1 = require("@shared-modules/components/title");
const file_loader_hooks_1 = require("@hooks/file-loader.hooks");
const loader_1 = require("@shared-modules/components/loader");
const button_1 = require("@shared-modules/components/button");
const translation_hooks_1 = require("@hooks/translation.hooks");
const no_img_png_1 = __importDefault(require("@assets/no-img.png"));
require("./styles.scss");
const IMG_TYPES = /\.(jpg|jpeg|png|gif|webp)$/;
const ProfileEditUploadPhoto = (props) => {
    const { uploadPhoto, profile } = props;
    const translator = (0, translation_hooks_1.usePagesTranslation)("profileEditPage.profileEditUploadPhoto");
    const [image, setImage] = (0, react_1.useState)();
    const [isLoaderVisible, setLoaderVisible] = (0, react_1.useState)(false);
    const newImageUrl = (0, file_loader_hooks_1.useFileLoader)(image);
    const avatarUrl = image ? newImageUrl : (profile === null || profile === void 0 ? void 0 : profile.avatar) || no_img_png_1.default;
    const handleImageChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const img = event.target.files[0];
        if (!img.name.match(IMG_TYPES)) {
            throw new Error("wrong image type");
        }
        setImage(img);
        setLoaderVisible(true);
        yield uploadPhoto(img);
        setLoaderVisible(false);
    });
    return (react_1.default.createElement("div", { className: "c-profile-edit-upload-photo" },
        react_1.default.createElement("div", { className: "c-profile-edit-upload-photo__avatar" },
            !isLoaderVisible && react_1.default.createElement(profile_avatar_1.ProfileAvatar, { width: "80px", height: "80px", src: avatarUrl }),
            isLoaderVisible && react_1.default.createElement(loader_1.Loader, null)),
        react_1.default.createElement("div", { className: "c-profile-edit-upload-photo__text-container" },
            react_1.default.createElement(title_1.Title, { title: "Profile photo", tag: "h3" }),
            react_1.default.createElement("p", null, translator("description")),
            react_1.default.createElement("div", { className: "c-profile-edit-upload-photo__button" },
                react_1.default.createElement(button_1.Button, { type: "thirtery" },
                    react_1.default.createElement("label", { className: "c-profile-edit-upload-photo__label" },
                        react_1.default.createElement("input", { type: "file", className: "c-profile-edit-upload-photo__input", onChange: handleImageChange }),
                        translator("uploadPhotoButton")))))));
};
exports.ProfileEditUploadPhoto = ProfileEditUploadPhoto;
